import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'

// Admin pages
import Overview from 'src/components/Dashboard/Views/Overview.vue'
import Login from 'src/components/Dashboard/Views/Login.vue'

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    beforeEnter: (to, from, next) => {
      console.info('/')
      if (localStorage.getItem('api_token')) {
        next('/admin')
      } else {
        next('/login')
      }
    }
  },
  {
    path: '/login',
    component: Login,
    name: 'Login',
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem('api_token')) {
        next('/admin')
      } else {
        next()
      }
    }
  },
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/',
    beforeEnter: (to, from, next) => {
      console.log('Aquí merengues mi leidi')
      if (localStorage.getItem('api_token')) {
        next()
      } else {
        next('/login')
      }
    },
    children: [
      {
        path: '',
        name: 'Overview',
        component: Overview
      }
    ]
  },
  { path: '*', component: NotFound }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js